import React from "react";
import { Route, Routes } from "react-router-dom";
import Error404 from "../Pages/Error404";
import {
  Otpvalidation,
  StudentLogin,
  Profile,
  Studentdashboard,
  Newpassword,
  Studentselection,
  StudentCourseSelection,
  StudentInstructions,
  StudentForgetPassword,
  StudentChangePassword,
  StudentExamRegistration,
  StudentResultview,
  StudentEPaperCopyview,
  StudentCOAttainment,
  StudentPaymentresponse,
  Payment,
  StudentHelp,
  PaymentBills,
  ScrutinyComplaints,
  Condonation,
  StudentCondonationPayResponse,
  CondonationPayment,
  StudentBvocCourseSelection,
  StudentSupplementary,
  SupplementaryPayment,
  StudentSupplementaryResponse,
  StudentReadmission,
  StudentReadmissionResponse,
  ReadmissionPayment,
  Academiccredit,
  StudentInternship
} from "../Pages/Student";

import Viewresult from "../Pages/Viewresult";

import ProtectedRoute from "../component/ProtectedRoute";

const UserRoutes = () => (
  <Routes>
    <Route path="/*" element={<Error404 />} />
    <Route path="/" element={<StudentLogin />} />
    <Route path="/studentforgetpassword" element={<StudentForgetPassword />} />
    <Route path="/studentinstructions" element={<StudentInstructions />} />
    <Route path="/Otpvalidation" element={<Otpvalidation />} />
    <Route path="/Newpassword" element={<Newpassword />} />
    <Route
      path="/profile"
      element={<ProtectedRoute element={<Profile />} role={3} />}
    />
    <Route
      path="/studentdashboard"
      element={<ProtectedRoute element={<Studentdashboard />} role={3} />}
    />
    <Route
      path="/studentselection"
      element={<ProtectedRoute element={<Studentselection />} role={3} />}
    />
    <Route
      path="/studentcourseselection"
      element={<ProtectedRoute element={<StudentCourseSelection />} role={3} />}
    />
    <Route
      path="/studentchangepassword"
      element={<ProtectedRoute element={<StudentChangePassword />} role={3} />}
    />
    <Route
      path="/studentexamregistration"
      element={
        <ProtectedRoute element={<StudentExamRegistration />} role={3} />
      }
    />
    <Route
      path="/studentresult"
      element={<ProtectedRoute element={<StudentResultview />} role={3} />}
    />
    <Route
      path="/studentepapercopyview"
      element={<ProtectedRoute element={<StudentEPaperCopyview />} role={3} />}
    />
    <Route
      path="/studentpaymentresponse"
      element={<ProtectedRoute element={<StudentPaymentresponse />} role={3} />}
    />
    <Route
      path="/studentcoattainment"
      element={<ProtectedRoute element={<StudentCOAttainment />} role={3} />}
    />
    <Route
      path="/payment"
      element={<ProtectedRoute element={<Payment />} role={3} />}
    />
    <Route
      path="/studenthelp"
      element={<ProtectedRoute element={<StudentHelp />} role={3} />}
    />
    <Route path="/viewresult" element={<Viewresult />} />
    <Route
      path="/paymentbills"
      element={<ProtectedRoute element={<PaymentBills />} role={3} />}
    />
    <Route
      path="/scrutinycomplaints/:id"
      element={<ProtectedRoute element={<ScrutinyComplaints />} role={3} />}
    />
    <Route
      path="/condonation"
      element={<ProtectedRoute element={<Condonation />} role={3} />}
    />
    <Route
      path="/condonationResponse"
      element={
        <ProtectedRoute element={<StudentCondonationPayResponse />} role={3} />
      }
    />
    <Route
      path="/condonationPayment"
      element={<ProtectedRoute element={<CondonationPayment />} role={3} />}
    />
    <Route
      path="/studentsupplyorbetterment"
      element={<ProtectedRoute element={<StudentSupplementary />} role={3} />}
    />
    <Route
      path="/studentreadmission"
      element={<ProtectedRoute element={<StudentReadmission />} role={3} />}
    />
    <Route
      path="/readmissionresponse"
      element={<ProtectedRoute element={<StudentReadmissionResponse />} role={3} />}
    />
    <Route
      path="/readmissionpayment"
      element={<ProtectedRoute element={<ReadmissionPayment />} role={3} />}
    />
    <Route
      path="/supplyResponse"
      element={
        <ProtectedRoute element={<StudentSupplementaryResponse />} role={3} />
      }
    />
    <Route
      path="/supplementaryPayment"
      element={<ProtectedRoute element={<SupplementaryPayment />} role={3} />}
    />

     <Route
      path="/externalcredit"
      element={<ProtectedRoute element={<Academiccredit />} role={3} />}
    />
     <Route
      path="/studentinternship"
      element={<ProtectedRoute element={<StudentInternship />} role={3} />}
    />
    //Bvoc
    <Route
      path="/studentbvoccourseselection"
      element={
        <ProtectedRoute element={<StudentBvocCourseSelection />} role={3} />
      }
    />
  </Routes>
);

export default UserRoutes;
